export default __webpack_public_path__ + "static/SalfordScorpions-0c0dc4e0fbcf39b133143ee7ef6df309.jpg";